// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"737":"85d3d14a","881":"85d3d14a"}[chunkId] + ".chunk.css";
};